import * as Api from '@ViewModels';
import { css, StyleSheet } from 'aphrodite';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { useAICampaignDetails } from '../../../../queries/AICampaign';
import { LoadingSpinner } from '../../../components/LoadingSpinner';
import { EditQueuedCampaign } from '../../EditQueuedCampaign';

/**
 * Kept only as a landing route: the day-before notification email and the campaign report link here by campaign id.
 * Reviewing happens on the queued campaign view itself now, so this loads the campaign and hands over to it.
 */
export const AICampaignReviewPage: React.FC = () => {
	const { campaignId } = useParams<{ campaignId: string }>();
	const userSession = useUserSession();

	const { data: campaign, isLoading } = useAICampaignDetails({ bulkEmailMessageId: campaignId });
	const campaignViewModel = useMemo(
		() => (campaign ? new Api.CampaignViewModel(userSession, campaign) : null),
		[campaign, userSession]
	);

	if (isLoading || !campaignViewModel) {
		return (
			<div className={css(styleSheet.loading)}>
				<LoadingSpinner type='large' />
			</div>
		);
	}

	return <EditQueuedCampaign campaign={campaignViewModel} />;
};

const styleSheet = StyleSheet.create({
	loading: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		width: '100%',
	},
});
